<template>
  <div>
    <accordion-panel
      class="user-editing-permissions-groups avoid-break checkbox-group"
      v-for="(group, index) in groups"
      :key="group.name"
      :id="group.name"
      :collapsed.sync="collapsedPanels[index]"
    >
      <template #title>
        <label class="mb-0">
          {{ $t(`permissions.groups.${group.name}`) }}
        </label>
      </template>

      <permission-items
        :user="user"
        :permissions="group.permissions"
        :is-disabled="isDisabled"
      />

      <div v-if="group.children && group.children.length">
        <permission-sub-groups
          :user="user"
          :sub-groups="group.children"
          :is-disabled="isDisabled"
        />
      </div>
    </accordion-panel>
  </div>
</template>

<script>
import PermissionItems from '@/domain/components/generalPanel/adminPanel/user/editing/PermissionItems';
import PermissionSubGroups from '@/domain/components/generalPanel/adminPanel/user/editing/PermissionSubGroups';
import AccordionPanel from '@/components/AccordionPanel';

export default {
  name: 'permission-groups',
  components: {
    PermissionItems,
    PermissionSubGroups,
    AccordionPanel,
  },
  props: {
    user: Object,
    groups: Array,
    isDisabled: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      collapsedPanels: [],
    };
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .user-editing-permissions-groups
    margin-top: 1rem
    border: 1px solid $color-border-gray
    border-radius: 5px
  ::v-deep
    .accordion-panel
      &__header
        padding: 2px 15px !important
        font-weight: bold
</style>
